import http from 'hub-http/clients/apiClient';
const fetchUser = ({
  userId
}) => {
  return http.get(`app-users/v1/users/batch?id=${userId}`);
};
export default fetchUser;